module.exports = __webpack_public_path__ + "static/media/scds2016.e12aac7f.gif";